class ColorBackground {
    constructor(element) {
        this._element = element;
    }

    setColor(color) {
        this._element.style.background = color;
    }
}

export default ColorBackground;
